export default __webpack_public_path__ + "static/media/em-banner2-ar.ad0b57e7.png";